import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { MultiSelectionComponent } from "../../MultiSelectionComponent/MultiSelectionComponent";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import {
  GET_VEHICLE_CATEGORY,
  GET_VEHICLE_TYPE,
} from "../AddVendorAccount/UserPreferenceAndVehicleCategory/SelectedLanes";
import { Vehicle_Managent_Inputs } from "./AddMyVehicleManagent.config";
import "./AddVehicleManagent.scss";
import pathState from "../../../../atoms/pathstate";
import { useRecoilState } from "recoil";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

export const GET_VEHICLE_LENGTH = gql`
  query SearchVehicleLengthMasters($keyword: String) {
    searchVehicleLengthMasters(keyword: $keyword) {
      _id
      length
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

const EDIT_VEHICLE_MANAGEMENT = gql`
  mutation EditVehicleManagement($id: ID!, $Account_ID: ID, $userInput: VehicleManagementInput!) {
    editVehicleManagement(id: $id, Account_ID: $Account_ID, userInput: $userInput) {
      _id
      Unique_Id
      Vehicle_No
      Nick_Name
      Vehicle_Length
      Payload_Capacity
      Account_Name
      Vehicle_Type
      Vehicle_Category
      createdAt
      updatedAt
    }
  }
`;

const CREATE_VEHICLE_MANAGEMENT = gql`
  mutation CreateVehicleManagement($createInput: VehicleManagementInput!, $Account_ID: ID) {
    createVehicleManagement(createInput: $createInput, Account_ID: $Account_ID) {
      _id
    }
  }
`;
const Get_Vehicle_By_Id = gql`
  query VehicleManagement($id: ID!) {
    VehicleManagement(id: $id) {
      _id
      Account_ID {
        _id
        Account_Name
      }
      Vehicle_No
      Nick_Name
      Payload_Capacity
      Vehicle_Length
      Vehicle_Category {
        _id
        Vehicle_Type
      }
    }
  }
`;

const AddMyVehicleManagent = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  let Form_Key = "My_Vehicle_Management";
  const formRef = useRef({});
  const [FormData, setFormdata] = useState<any>({});
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [isFirstLoad, setFirstLoad] = useState(false);
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, " My Vehicle Managent");
  const [vehicleCategory, setCategory] = useState("");
  const [vehicleType, setVehicleType] = useState<any>("");
  const [toggle, settoggle] = useState(show ? show : false);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.["My_Vehicle_Management"]?.Selected_Row;
  const [{ CurrentTitle }] = useRecoilState(pathState);
  const [allFieldsData, setAllFieldsData] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  //Q & M
  const [CreateVechicle, { loading: CreateVechicleload, error: error_v }] = useMutation(CREATE_VEHICLE_MANAGEMENT, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(Get_Vehicle_By_Id, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });

  const [edit_vehicle_Management, { loading: EditBranchMaster }] = useMutation(EDIT_VEHICLE_MANAGEMENT, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);

    if (!Error) {
      submit();
    }
  };
  const VehicleLoadingState = CreateVechicleload || EditBranchMaster || GetDataByIDLoader;

  useEffect(() => {
    if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let vehicle = { ...data?.VehicleManagement };

        dispatch({
          type: "SearchMasterData",
          payload: {
            Account_ID: vehicle?.Account_ID,
          },
        });
        vehicle.Account_ID = vehicle?.Account_ID?.Account_Name;
        setCategory(vehicle?.Vehicle_Category?._id);
        setVehicleType(vehicle?.Vehicle_Category?.Vehicle_Type);
        setAllFieldsData(vehicle);
        updateValueForm(formRef, vehicle);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  const handleAdd_vehicle_number = () => {
    setShowModal(true);
  };

  const submit = async (close: String) => {
    let data: any = FormData;
    if (vehicleCategory) {
      data.Vehicle_Category = vehicleCategory;
    }
    if (vehicleType) {
      data.Vehicle_Type = vehicleType;
    }

    if (!vehicleType) {
      WarningToast("Please Select Vehicle Category");
      return;
    }
    if (data?.Payload_Capacity) {
      data.Payload_Capacity = String(data.Payload_Capacity);
    }
    if (TypeOfPortal === "Edit") {
      await edit_vehicle_Management({
        variables: { id: allFieldsData._id, userInput: data },
      })
        .then((res) => {
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          SuccessToast("Vehicle Master Edited Successfully");
          handleFormReset(formRef);
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      await CreateVechicle({
        variables: {
          createInput: data,
        },
      })
        .then((res) => {
          console.log(res);
          SuccessToast("Vehicle Created Successfully");
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          if (close === "Close") {
            Closeformfunction();
          }
          setAllFieldsData({});
          setCategory("");
          setVehicleType("");
          handleFormReset(formRef);
          ClearSpecificForm(dispatch, Form_Key);
        })
        .catch((err) => {
          settoggle(toggle);
          ErrorToast(err?.message);
        });
    }
    if (error_v) {
      ErrorToast(error_v?.message);
    }
  };

  const Closeformfunction = () => {

    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    setCategory("");
    setVehicleType("");
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveandcloseForadd = () => {
    submit("Close");
  };


  const storeSelectedData = (selectedCat, type, ckeck) => {
    if (ckeck) {
      setCategory(type?._id);
      setVehicleType(selectedCat?._id);
    } else {
      setCategory("");
      setVehicleType("");
    }
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      SaveAndClose={() => {
        TypeOfPortal === "Add" ? Validate_handleSubmit(SaveandcloseForadd) : Validate_handleSubmit(submit);
      }}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={VehicleLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
        >
          <>
            {VehicleLoadingState && <div className="loader-line-div" />}
            {showModal && (
              <MultiSelectionComponent
                firstLevelQuery={GET_VEHICLE_TYPE}
                secondLevelQuery={GET_VEHICLE_CATEGORY}
                storeSelectedData={storeSelectedData}
                show={showModal}
                Closeformfunction={() => {
                  setShowModal(false);
                }}
                submit={() => {
                  setShowModal(false);
                }}
                selectedData={vehicleCategory}
                handleCancle={() => setShowModal(false)}
              />
            )}
            <div className="formContainer">
              {Vehicle_Managent_Inputs.map((e, i) => {
                return (
                  <div className="FormSectionParent">
                    <div className="FormSection" style={{ width: "400px", maxWidth: "280px" }}>
                      <FormInputSectionComponent
                        TypeOfPortal={TypeOfPortal}
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        onErrorsChange={handleErrorsChange}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                        formkey={Form_Key}
                        setFirstLoad={setFirstLoad}
                      />
                      <div className="vehicle_category">
                        <p>Vehicle Category</p>
                        <Button
                          children=""
                          disabled=""
                          action={handleAdd_vehicle_number}
                          text={vehicleCategory ? "Selected" : "Select"}
                          name={"modalbutton"}
                          type={""}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddMyVehicleManagent;
